<div class="container">

  <div fxLayout="row wrap" fxLayoutAlign="center center">
    <div fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="title alicent">Our specialty is your data</div>
    </div>
  </div>


  <div fxLayout="row wrap" fxLayoutAlign="center center">
    <div fxFlex.xl="45" fxFlex.lg="45" fxFlex.md="45" fxFlex.sm="80" fxFlex.xs="80">
      <div class="paragraph alicent">EDClin&trade; is the new boutique data management platform that adapts perfectly to
        your
        Projects, designed by Clinical Research experts with the User at heart.<br>
        Whether you need an EDC for a first-in-man study of 20 patients or a global RWS of several thousands of
        patients, we have the
        modern, intuitive, compliant, patient-centric solution for you.
      </div>
    </div>
  </div>



  <div class="rowdiv">

    <div fxLayout="row wrap" fxLayoutAlign="center center">

      <div class="boxes" fxFlex fxLayout="row wrap"
        fxLayoutAlign="center start">

        <div fxLayout="column wrap" fxFlex.xs="75" fxFlex.sm="60" fxFlex.md="35" fxFlex.lg="35" fxFlex.xl="15">
          <div class="icon">
            <img src="assets/medias/img/edit.webp" alt="tech">
            <h5>Tech</h5>
            <p>Java EE, JSF, Angular, Web services, Oracle 12c, PostgreSQL, Android &amp; iOS apps.
              <br>You name it.
            </p>
          </div>
        </div>

        <div fxLayout="column wrap" fxFlex.xs="75" fxFlex.sm="60" fxFlex.md="35" fxFlex.lg="35" fxFlex.xl="15">
          <div class="icon">
            <img src="assets/medias/img/monitor.webp" alt="demo">
            <h5>Demo</h5>
            <p>Have a virtual tour of our application via the button in the navigation bar, or contact us for a personal
              demonstration.</p>
          </div>
        </div>

        <div fxLayout="column wrap" fxFlex.xs="75" fxFlex.sm="60" fxFlex.md="35" fxFlex.lg="35" fxFlex.xl="15">
          <div class="icon">
            <img src="assets/medias/img/layout.webp" alt="pricing">
            <h5>Pricing simulation</h5>
            <p>Choose your options and customize your specs. No hidden fees — you decide what to pay for.</p>
          </div>
        </div>

        <div fxLayout="column wrap" fxFlex.xs="75" fxFlex.sm="60" fxFlex.md="35" fxFlex.lg="35" fxFlex.xl="15">
          <div class="icon">
            <img src="assets/medias/img/world.webp" alt="contact">
            <h5>Contact us</h5>
            <p>We're looking forward to discussing details and deadlines with you!</p>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>

<app-footer></app-footer>
